"use client"
import { create } from "zustand"

interface LanguageModalStore {
  modalOpen: boolean
  setModalOpen: (open: boolean) => void
}

export const useLanguageModalStore = create<LanguageModalStore>(set => ({
  modalOpen: false,
  setModalOpen: open => set({ modalOpen: open }),
}))
